export default "__VITE_ASSET__BN_kUeX1__"